import React from 'react';
import ReactApexChart from 'react-apexcharts';


const DonutChart = ({colors, series, labels}:any) => {
    let options:any = {
        labels: labels,
        chart: {
            type: 'donut',
            height: 120,
        },
        colors: colors,
        legend: {
            show: false
        },
        dataLabels: {
            enabled: false
        }
    };
    return (
        <ReactApexChart
            dir="ltr"
            className="apex-charts"
            series={series}
            options={options}
            type="donut"
        />
    )
}
export default DonutChart;